export const GET_PRODUCT_RECOMMANDATIONS = `
    query productRecommendations($productId: ID!) {
        productRecommendations(productId: $productId) {
            id,
            title,
            availableForSale,
            variants(first: 2) {
                edges {
                    node {
                        id
                    }
                }
            },
            createdAt,
            priceRange {
                minVariantPrice {
                    amount,
                    currencyCode
                },
                maxVariantPrice {
                    amount,
                    currencyCode
                }
            },
            handle,
            compareAtPriceRange {
                minVariantPrice {
                    amount,
                    currencyCode
                }
            },
            images(first: 2) {
                edges {
                    node {
                        originalSrc
                        altText
                    }
                }
            },
            alternativeImage: metafield(namespace: "flambette_product", key: "alternative_image") {
                reference {
                    ... on MediaImage {
                        image {
                            originalSrc
                        }
                    }
                }
            }
        }
    }
`
